export default __webpack_public_path__ + "static/media/40.e9450848.jpg";